import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyCGosyf5BorVvd4nIPVK_ALbHBFn3T-fKM",
  authDomain: "inboxone-mail.firebaseapp.com",
  projectId: "inboxone-mail",
  storageBucket: "inboxone-mail.firebasestorage.app",
  messagingSenderId: "663223404351",
  appId: "1:663223404351:web:177407a4b40fa15048358a"
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const googleProvider = new GoogleAuthProvider()

export default app
